import {SiteCardSpec} from '@/app/model/common';
import {CommonModule} from '@angular/common';
import {Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {EventAPI} from "@/app/model/interface/event";

@Component({
    selector: 'app-site-card',
    imports: [CommonModule, TranslatePipe],
    templateUrl: './site-card.component.html',
    styleUrl: './site-card.component.scss',
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ]
})
export class SiteCardComponent implements OnInit {
    @Input() siteCardSpec: SiteCardSpec;
    @Input() event: EventAPI;

    constructor() {
    }

    ngOnInit() {
    }
}
